import { css } from '@emotion/react';
import { p2r, PrimaryProps } from '../../styles/fonts';
import { colors } from '../../styles/index';

const styles = css`
  width: 100%;
  max-width: 320px;

  &:hover {
    cursor: pointer;
  }

  .button-container-text {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: ${p2r(60)};
    font-size: ${p2r(18)};
    font-weight: 500;
    background-color: ${colors.lightOrange};
    transition: 0.2s background-color ease-out;

    span {
      padding: ${p2r(16)};
    }
  }

  .button-container-img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 54px;
    min-height: ${p2r(60)};
    overflow: hidden;
    background-color: ${colors.orange};

    img {
      transition: transform 0.5s ease;
    }
  }

  &:hover .button-container-img img {
    transform: scale(1.2);
  }

  &:hover .button-container-text {
    text-decoration: underline;
  }

  .button-link {
    color: ${colors.black};
    text-decoration: none;
  }

  .button-container {
    display: flex;
    align-items: center;
  }

  ${PrimaryProps}
`;

export default styles;
